import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAemConfig } from '@as-react/common-components';
import { Box, Carousel, Collapse, Column, ContentTile, CarouselVariant, SliderNavColor, SliderNavVariant, Heading, HeadingType, MediaQuery, } from '@as/cotopaxi';
import { SLIDE_SPACING } from '../../../constants/SliderConstants';
import { MIN_SCREEN_WIDTH_TABLET, MIN_SCREEN_WIDTH_DESKTOP } from '../../../constants/ScreenWidthConstants';
import { getCategoryAndTypeByTags } from '../../../util/content-lister/ContentListerUtil';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
const ProductRelevantContent = ({ content, collapsible, collapsed, title, types, categories, analyticsBannerId, }) => {
    const { t } = useTranslation([I18N_NAMESPACES.general]);
    const { mainWebShop } = useAemConfig();
    const contentSize = content.length;
    const isExtended = contentSize < 3;
    const slidesPerView = isExtended ? 2 : 3;
    const contentTileTranslations = {
        readMore: t(`${I18N_NAMESPACES.general}:readMore`),
    };
    const mainBoxParams = {
        mobile: { spacing: { paddingTop: collapsible ? 0 : 2 } },
        tablet: { spacing: { paddingBottom: 5, paddingTop: 0 } },
        dataAttributes: { 'data-analytics-bannerid': analyticsBannerId },
    };
    const innerBoxParams = {
        mobile: {
            spacing: {
                paddingBottom: 3,
                paddingTop: collapsible ? 0 : 2,
            },
        },
        tablet: {
            spacing: {
                paddingBottom: 0,
                paddingTop: 0,
                marginTop: 2,
            },
        },
        mobileBleed: !collapsible,
        tabletBleed: !collapsible,
    };
    const carouselConfig = {
        variant: CarouselVariant.CONTENT_TILE,
        arrowsConfig: {
            color: SliderNavColor.BASE,
            variant: SliderNavVariant.CIRCLE,
        },
        showPagination: true,
        configurationOverrides: {
            preventClicks: true,
            slidesPerView: 'auto',
            spaceBetween: SLIDE_SPACING.MOBILE,
            watchOverflow: true,
            shouldSwiperUpdate: true,
            breakpoints: {
                [MIN_SCREEN_WIDTH_TABLET]: {
                    slidesPerView,
                    spaceBetween: SLIDE_SPACING.MOBILE,
                },
                [MIN_SCREEN_WIDTH_DESKTOP]: {
                    slidesPerView,
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                },
            },
        },
    };
    const slides = content.map(c => (_jsx(Column, { grid: 0, gutter: false, desktop: 12 / contentSize, children: _jsx(Box, { tablet: { spacing: { paddingBottom: 2 } }, children: _jsx(ContentTile, { href: c.url, tags: getCategoryAndTypeByTags(mainWebShop, c.tags, types, categories), title: c.title, text: c.description, image: { src: c.image, backgroundImage: true, lazy: true }, extended: isExtended, translations: contentTileTranslations }) }) }, c._id)));
    if (!(content === null || content === void 0 ? void 0 : content.length)) {
        return null;
    }
    if (collapsible) {
        return (_jsx(Box, Object.assign({}, mainBoxParams, { children: _jsx(Collapse, { id: "product-relevant-content-collapse", title: title, open: !collapsed, query: [MediaQuery.MOBILE, MediaQuery.TABLET_SMALL], mobileFullwidth: true, tabletFullwidth: true, desktopFullwidth: true, children: _jsx(Box, Object.assign({}, innerBoxParams, { children: _jsx(Carousel, Object.assign({}, carouselConfig, { children: slides })) })) }) })));
    }
    return (_jsxs(Box, Object.assign({}, mainBoxParams, { children: [_jsx(Heading, { type: HeadingType.SMALL_TITLE, children: title }), _jsx(Box, Object.assign({}, innerBoxParams, { children: _jsx(Carousel, Object.assign({}, carouselConfig, { children: slides })) }))] })));
};
export default ProductRelevantContent;
